
export default function TrustSection() {
  return (
    <section className="py-16 bg-[#f5f5f5]">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            "三真"承诺体系
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            透明化体系 · 数据化标准 · 可视化体验
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 真产地 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-[#cc9966]/20">
            <div className="text-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <i className="ri-map-pin-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-2">真产地</h3>
              <p className="text-xs sm:text-sm text-[#cc9966] font-semibold">云南核心产区</p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">深入云南六大茶山核心产区</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">500+合作源头仓及厂家源头把控</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">3个20,000平标准智能化酵藏仓</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">18位藏茶专家严苛审评</p>
              </div>
            </div>
            
            <div className="mt-6 p-4 bg-[#cc9966]/10 rounded-lg">
              <p className="text-xs sm:text-sm text-[#663333] font-medium">
                每一片茶叶都有明确的产地标识，确保原产地正宗性
              </p>
            </div>
          </div>

          {/* 真年份 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-[#cc9966]/20">
            <div className="text-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <i className="ri-time-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-2">真年份</h3>
              <p className="text-xs sm:text-sm text-[#cc9966] font-semibold">证据链可追溯</p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">完整制作时间记录</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">入库存储时间档案</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">年度品质检测报告</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">区块链技术防伪溯源</p>
              </div>
            </div>
            
            <div className="mt-6 p-4 bg-[#cc9966]/10 rounded-lg">
              <p className="text-xs sm:text-sm text-[#663333] font-medium">
                建立完整证据链条，让每一个年份都有据可查
              </p>
            </div>
          </div>

          {/* 真转化 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-[#cc9966]/20">
            <div className="text-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <i className="ri-flask-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#663333] mb-2">真转化</h3>
              <p className="text-xs sm:text-sm text-[#cc9966] font-semibold">科学仓贮管理</p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">8,000㎡标准化专业仓库</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">恒温22-28℃精确控制</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">恒湿60-70%科学管理</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full flex-shrink-0"></div>
                <p className="text-xs sm:text-sm text-gray-600">24小时智能监控系统</p>
              </div>
            </div>
            
            <div className="mt-6 p-4 bg-[#cc9966]/10 rounded-lg">
              <p className="text-xs sm:text-sm text-[#663333] font-medium">
                科学的仓储环境，确保茶叶完美自然转化
              </p>
            </div>
          </div>
        </div>

        {/* 品控流程 */}
        <div className="mt-16 bg-white rounded-2xl p-8 lg:p-12 shadow-lg border border-[#cc9966]/20">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#663333] text-center mb-8">
            标准化品控流程
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">入库审评</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                专业审评师对每批茶叶进行感官品质评定，确保符合入库标准
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">年度体检</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                定期检测茶叶转化情况，调整仓储环境，确保最佳陈化效果
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">出厂检验</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                出厂前最后一道品质把关，确保每一款产品都达到完美状态
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
